/**
 * Hand a blob to the browser as a download. The object URL is revoked on a
 * timer rather than immediately: Safari starts the transfer asynchronously and
 * a URL revoked in the same tick cancels the download it was created for.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
